export default __webpack_public_path__ + "static/media/perspective_icon.e82ef613.png";